import { useAnnouncer } from '../state/announcer.ts';

/** The single polite status region. Render once near the app root. */
export function LiveRegion() {
  const { message, nonce } = useAnnouncer();
  return (
    <div className="sr-only" role="status" aria-live="polite" aria-atomic="true">
      {/* Keyed so a repeated message is announced again. */}
      <span key={nonce}>{message}</span>
    </div>
  );
}
